export default "__VITE_ASSET__CAYuwSmI__"